import { useEffect, useContext } from "react";
import { GlobalContext } from "../../context/global/globalContext";
import Container from "../../components/commons/Container";
import classes from "../../scss/Services.module.scss";
import { v4 as uuid } from "uuid";
import Card from "./Card";
import RobotSmall from "./RobotSmall";
import { Loader } from "../../components/Loader";
import gsap from "gsap";
import {ReactComponent as HeroImage} from "../../assets/img/Services/services_hero.svg";
const Services = () => {
  const { services, getServices } = useContext(GlobalContext);

  gsap.config({
    force3D: false,
    nullTargetWarn: false,
  });

  const tl = gsap.timeline();

  useEffect(() => {
    if (!services) {
      getServices();
    }
  }, [getServices, services]);

  useEffect(() => {
    tl.to(`.${classes.services__cards}`, {
      y: 0,
      duration: 1,
      ease: "back.out(1)",
    })
      .to(
        `.${classes.services__image}`,
        {
          x: 0,
          duration: 1,
          ease: "back.out(1)",
        },
        "<"
      )
      .to(
        `.${classes.services__content}`,
        {
          z: 0,
          autoAlpha: 1,
          duration: 1,
          ease: "back.out(5)",
        },
        "<"
      );
  }, [tl]);

  if (!services) {
    return <Loader />;
  }

  return (
    <section className={classes.services}>
      <Container className={classes.services__container}>
        <div className={classes.services__body}>
          <section className={classes.services__hero}>
            <article className={classes.services__content}>
              <h2 className={classes.services__title}>Services</h2>
              <p className={classes.services__text}>
                Agilistry offers the widest range of services for E2E mobile
                development. We offer turnkey development as well as improvement
                and refinement of existing solutions. Get new satisfied users
                and make technological breakthroughs with our help.
              </p>
            </article>
            <div className={classes.services__image}>
              <HeroImage />
            </div>
          </section>
          <section className={classes.services__cards}>
            {services?.map((service) => {
              return(
                  <Card
                      key={uuid()}
                      slug={service.custom_fields.slug || service.slug}
                      title={service.title.rendered}
                      text={service.custom_fields.shortDescription || service.custom_fields._yoast_wpseo_metadesc}
                      order={service.custom_fields.order}
                      className={classes.services__card}
                  />
              )
            })}
          </section>
        </div>
      </Container>
    </section>
  );
};

export default Services;
